export var DefaultHost;
(function (DefaultHost) {
    DefaultHost["Api"] = "https://api.notes.noimfamily.com";
    DefaultHost["WebSocket"] = "wss://api.notes.noimfamily.com";
})(DefaultHost || (DefaultHost = {}));
